import { isValidEmail } from 'data/string';
import CSVParser from 'assets/js/export-csv';
import { ORGANIZATION_INVITATION_MODAL_CANCEL, ORGANIZATION_INVITATION_MODAL_CSV, ORGANIZATION_INVITATION_MODAL_DOWNLOAD_TEMPLATE, ORGANIZATION_INVITATION_MODAL_INVITE_BUTTON, ORGANIZATION_INVITATION_SUCCESS_BUTTON, } from '../TenantSegmentEvents';
import './inviteMemberModal.scss';
var rolesEnum;
(function (rolesEnum) {
    rolesEnum["guest"] = "guest";
    rolesEnum["member"] = "member";
    rolesEnum["admin"] = "admin";
})(rolesEnum || (rolesEnum = {}));
const SAMPLE_CONTENT = Array.from(Array(5).keys()).map((_, key) => {
    return {
        text: `teste${key}@empresa.com.br`,
    };
});
export class InviteMemberModalController {
    static $inject = ['close', '$timeout', 'FileSaver', 'TenantService', 'ContextProcessorService', 'LoadingService', '$translate', 'SegmentService', 'BlipToastService'];
    constructor(close, $timeout, FileSaver, TenantService, ContextProcessorService, LoadingService, $translate, SegmentService, BlipToastService) {
        'ngInject';
        this.close = close;
        this.$timeout = $timeout;
        this.FileSaver = FileSaver;
        this.TenantService = TenantService;
        this.ContextProcessorService = ContextProcessorService;
        this.LoadingService = LoadingService;
        this.$translate = $translate;
        this.SegmentService = SegmentService;
        this.BlipToastService = BlipToastService;
        this.emails = [];
        this.validForm = false;
        this.emailListHasExistentUser = false;
        this.maximumContact = 30;
        this.onChangeRole = event => {
            const { value } = event.detail;
            this.role = value;
        };
        this.onChangeEmails = async (event) => {
            const { value, data } = event.detail;
            this.handleEmailInput(value, data);
        };
        this.onBlurEmails = async () => {
            const isValidInput = await this.inputEmailElement.isValid();
            const value = this.inputEmailElement.value;
            this.handleEmailInput(value);
            this.convertValueToChip();
            this.setInputValidity(isValidInput);
            await this.checkExistentUserInEmailList();
        };
        this.roleOptionsPermission = async () => {
            this.roleOptions = {
                guest: {
                    label: await this.$translate('inviteMemberModal.guest'),
                    description: await this.$translate('inviteMemberModal.guestDescription'),
                    icon: 'eye-open',
                    value: 'guest',
                },
                member: {
                    label: await this.$translate('inviteMemberModal.member'),
                    description: await this.$translate('inviteMemberModal.memberDescription'),
                    icon: 'edit',
                    value: 'member',
                },
                admin: {
                    label: await this.$translate('inviteMemberModal.admin'),
                    description: await this.$translate('inviteMemberModal.adminDescription'),
                    icon: 'avatar-user',
                    value: 'admin',
                },
            };
        };
        this.getCustomEventElements = () => {
            const selectMemberEmails = document.querySelector('#member-emails');
            selectMemberEmails.addEventListener('bdsChangeChips', event => this.onChangeEmails(event));
            selectMemberEmails.addEventListener('bdsBlur', () => this.onBlurEmails());
            const selectRole = document.querySelector('#role-permission');
            selectRole.addEventListener('bdsChange', event => this.onChangeRole(event));
        };
        this.setInputValidity = (value) => {
            this.inputEmailElement.danger = !value;
            this.validForm = value;
        };
        this.downloadTemplate = () => {
            this.SegmentService.createOrganizationTrack(ORGANIZATION_INVITATION_MODAL_DOWNLOAD_TEMPLATE);
            const { file } = CSVParser.CSVAsBlob({
                data: SAMPLE_CONTENT,
                hasHeader: false,
                columnDelimiter: '\t',
            });
            this.FileSaver.saveAs(file, 'example.csv');
        };
        this.$onInit();
    }
    async $onInit() {
        await this.roleOptionsPermission();
        this.invalidEmailError = await this.$translate('inviteMemberModal.invalidEmail');
        // it will override the blip-ds style while we dont have a select that overflows the modal.
        customElements.whenDefined('bds-select').then(async () => {
            const select = document.querySelector('bds-select');
            await select.componentOnReady();
            const selectOptions = select.shadowRoot.querySelector('div > .select__options');
            selectOptions.setAttribute('style', 'width: 140%');
        });
        this.getCustomEventElements();
        this.isLoading = false;
        this.pages = {
            intitation: true,
            success: false,
        };
    }
    get inputEmailElement() {
        return document.querySelector('#member-emails');
    }
    handleEmailInput(value, data) {
        if (value && !Array.isArray(value)) {
            if (isValidEmail(value.trim())) {
                if (!this.emails.includes(value)) {
                    this.emails = data ? data : [...this.emails, value];
                }
                return;
            }
        }
        else {
            if (!this.inputEmailElement.value) {
                if (data === undefined) {
                    return;
                }
                this.emails = [];
            }
        }
    }
    async checkExistentUserInEmailList() {
        const tenantUsersResource = await this.TenantService.getTenantUsers(this.ContextProcessorService.tenant.id);
        const currentTenantEmails = tenantUsersResource.items.map(tu => tu.fullName);
        this.emailListHasExistentUser = currentTenantEmails.some(tenantEmail => this.emails.some(email => tenantEmail === email));
    }
    async csvSelected() {
        this.SegmentService.createOrganizationTrack(ORGANIZATION_INVITATION_MODAL_CSV);
        const fileReader = new FileReader();
        fileReader.onload = async () => {
            if (fileReader.readyState == fileReader.DONE && fileReader.result) {
                const loadedEmails = fileReader.result.toString().split('\n');
                if (loadedEmails.length > this.maximumContact) {
                    const msg = `${await this.$translate('inviteMemberModal.maximumQuantityContact')} ${this.maximumContact}`;
                    this.BlipToastService.show('danger', {
                        msg,
                    });
                    document.getElementById('load-excel').value = '';
                    return;
                }
                this.$timeout(async () => {
                    const formattedEmails = loadedEmails.filter(email => {
                        if (!email.startsWith('sep=') && email.length > 0) {
                            return email.trim();
                        }
                    });
                    this.inputEmailElement.chips = formattedEmails;
                    this.emails = formattedEmails;
                    const isValidInput = await this.inputEmailElement.isValid();
                    this.setInputValidity(isValidInput);
                    document.getElementById('load-excel').value = '';
                    await this.checkExistentUserInEmailList();
                });
            }
        };
        fileReader.onerror = () => {
            console.error('Cannot read file');
        };
        fileReader.readAsText(this.csvFile);
    }
    async inviteMembers() {
        this.pages.intitation = false;
        this.isLoading = true;
        const currentTenant = this.ContextProcessorService.tenant;
        try {
            const emails = [...new Set(this.emails)];
            await this.TenantService.inviteMany(emails, currentTenant.id, this.role);
            this.isLoading = false;
            this.pages.success = true;
            this.SegmentService.createOrganizationTrack(ORGANIZATION_INVITATION_MODAL_INVITE_BUTTON, {
                usersInvited: this.emails.length,
                role: this.role,
            });
        }
        catch (e) {
            this.close();
            console.error(e);
            const msg = await this.$translate('inviteMemberModal.sendingError');
            this.BlipToastService.show('danger', {
                msg,
            });
        }
    }
    closeModal() {
        if (this.pages.success) {
            this.SegmentService.createOrganizationTrack(ORGANIZATION_INVITATION_SUCCESS_BUTTON);
        }
        else {
            this.SegmentService.createOrganizationTrack(ORGANIZATION_INVITATION_MODAL_CANCEL);
        }
        this.close(true);
    }
    openExplorer() {
        document.getElementById('load-excel').click();
    }
    async convertValueToChip() {
        if (!this.inputEmailElement.value) {
            return;
        }
        await this.inputEmailElement.add(this.inputEmailElement.value);
        this.inputEmailElement.value = '';
    }
}
InviteMemberModalController.$inject = ['close', '$timeout', 'FileSaver', 'TenantService', 'ContextProcessorService', 'LoadingService', '$translate', 'SegmentService', 'BlipToastService'];
